import { c as _c } from "react/compiler-runtime";
import Avatar from '@precis-digital/kurama/Avatar';
import Grid from '@precis-digital/kurama/Grid';
import Typography from '@precis-digital/kurama/Typography';
import { useTranslation } from 'shared/translations';
interface FormLabelProps {
  labelText: React.ReactNode;
  labelChip?: React.ReactNode;
  required?: boolean;
  iconUrl?: string;
  secondaryLabel?: React.ReactNode;
  renderLabel?: (labelText: React.ReactNode) => React.ReactNode;
  renderSecondaryLabel?: (secondaryLabel: React.ReactNode) => React.ReactNode;
}
const FormLabel = t0 => {
  const $ = _c(19);
  const {
    labelText,
    required,
    iconUrl,
    secondaryLabel,
    labelChip,
    renderLabel,
    renderSecondaryLabel
  } = t0;
  const {
    t
  } = useTranslation("common");
  let t1;
  if ($[0] !== iconUrl) {
    t1 = iconUrl != null && <Avatar size="small" kind="image" imageUrl={iconUrl} />;
    $[0] = iconUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== labelText || $[3] !== renderLabel) {
    t2 = renderLabel != null ? renderLabel(labelText) : <Typography variant="h5">{labelText}</Typography>;
    $[2] = labelText;
    $[3] = renderLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== required || $[6] !== t) {
    t3 = required !== undefined && <Typography variant="body3">{required ? t("form.required") : t("form.optional")}</Typography>;
    $[5] = required;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== labelChip || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <Grid display="flex" gap="8px" alignItems="center">{t1}{t2}{t3}{labelChip}</Grid>;
    $[8] = labelChip;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== renderSecondaryLabel || $[14] !== secondaryLabel) {
    t5 = renderSecondaryLabel != null ? renderSecondaryLabel(secondaryLabel) : <Typography variant="body3">{secondaryLabel}</Typography>;
    $[13] = renderSecondaryLabel;
    $[14] = secondaryLabel;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default FormLabel;